<!-- =========================================================================================
    File Name: ChatNavbar.vue
    Description: Chat Application - Chat navbar
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div v-if="userId != null" class="chat__header">
        <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
            <div class="relative flex mr-4">
                <feather-icon icon="MenuIcon" class="mr-4 cursor-pointer" v-if="isSidebarCollapsed" @click.stop="$emit('openContactsSidebar')" />
                <vs-avatar class="m-0 border-2 border-solid border-white" size="40px" :src="chatGroup.iconUrl" @click.stop="$emit('showProfileSidebar', userId)" />
            </div>
            <h6>{{ chatGroup.name }}</h6>              
            <vs-spacer></vs-spacer>
            <feather-icon icon="EditIcon" class="cursor-pointer ml-5" @click="editGroup" />
            <feather-icon icon="MessageCircleIcon" class="cursor-pointer ml-5" @click="$emit('openSponsoredPost')" />
            <v-select   
              class="ml-5 sm:w-3/12"   
              label="name"
              :options="languages"
              placeholder="Language"
              :reduce="item => item.value" 
              v-model="targetLanguage"
            />
            <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current': isPinnedLocal}, 'w-6', 'h-6']" @click.stop="isPinnedLocal = !isPinnedLocal"></feather-icon> -->  
                      
        </vs-navbar>
    </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  props: {
    chatGroup: {
      type: Object,
      default: {}
    },
    userId: {
      type: String,
      required: true
    },
    isPinnedProp: {
      type: Boolean,
      required: true
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    }
  },
  components: {
    "v-select": vSelect,
  },
  data(){
    return {
       languages: [
        { name: "English", value: "en" },
        { name: "Mandarin", value: "zh" },
        { name: "Thai", value: "th" },
        { name: "German", value: "de" },
        { name: "Spanish", value: "es" },
        { name: "Hindi", value: "hi" },
        { name: "Portuguese", value: "pt" },
        { name: "Arabic", value: "ar" },
        { name: "French", value: "fr" },
        { name: "Japanese", value: "ja" },
        { name: "Russian", value: "ru" },
      ],
      targetLanguage: null
    }
  },
  computed: {
    isPinnedLocal: {
      get () {
        return this.isPinnedProp
      },
      set (val) {
        const chatData = this.$store.getters['chat/chatDataOfUser'](this.userId)
        if (chatData) {
          const payload = { id: this.userId, value: val }
          this.$store.dispatch('chat/toggleIsPinned', payload)
            .then(() => { this.$emit('toggleIsChatPinned', val) })
            .catch((err) => { console.error(err) })
        } else {
          this.$emit('toggleIsChatPinned', val)
        }
      }
    },
    userDetails () {
      return this.$store.getters['chat/contact'](this.userId)
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    }
  },
  watch: {
    targetLanguage (val){
      this.$emit('targetLanguageSet', val);
    }
  },
  methods: {
    editGroup(){
      this.$router
        .push({
          name: "chatgroup-edit",
          params: {
            id: this.userId
          }
        })
    },
    getUserStatus (isActiveUser) {
      return isActiveUser ? true : false
    }
  }
}

</script>

